// src/utils/discountDayOfWeekCsvUtils.js

/**
 * Convert an array of objects into a CSV string.
 * Headers are object keys from the first element.
 * @param {Object[]} objArray
 * @returns {string}
 */
export function convertToCSV(objArray) {
  if (!Array.isArray(objArray) || objArray.length === 0) return "";

  const headers = Object.keys(objArray[0]);
  const escape = (val) => {
    let str = val == null ? "" : String(val);
    if (str.includes('"')) str = str.replace(/"/g, '""');
    return `"${str}"`;
  };

  // header row
  let csv = headers.map(escape).join(",") + "\r\n";

  // data rows
  objArray.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

/**
 * Build and download a CSV of discount transactions by day of week.
 *
 * @param {Object[]} transactions      - filtered list of transactions
 * @param {string}   [brandName]
 * @param {string}   [fileName]
 */
export function exportDiscountDayOfWeekCSV(
  transactions,
  brandName = "Angels Pizza",
  fileName = "Transactions_Discount Value_Day of Week.csv"
) {
  if (!Array.isArray(transactions)) {
    console.error("exportDiscountDayOfWeekCSV: expected an array");
    return;
  }

  // exclude zero-discount transactions
  const withDiscount = transactions.filter(
    (tx) => Number(tx.discount_amount || 0) > 0
  );

  // map to flat objects matching headers
  const rows = withDiscount.map((tx) => {
    const date = new Date(tx.tran_date).toISOString().split("T")[0];
    const store = tx.store_code.split("_")[1] || tx.store_code;
    return {
      Brand: brandName,
      Store: store,
      Date: date,
      "Discount Name": tx.discount_name || "",
      "Discount Amount": Number(tx.discount_amount || 0).toFixed(2),
    };
  });

  // convert to CSV
  const csvString = convertToCSV(rows);
  if (!csvString) {
    console.warn("exportDiscountDayOfWeekCSV: no data to export");
    return;
  }

  // trigger download
  const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
